import React, { useEffect } from "react";
import { PageHeaderWrapper } from "@ant-design/pro-layout";
import { connect } from "dva";
import { ShipmentStatus } from "@/utils/enum";
import { getUrlParams } from "@/utils/utils";
// import { SwapOutlined } from "@ant-design/icons";
import CopyableGUID from "@/components/CopyableGUID";
import DealerExchangeModal from "@/components/DealerExchangeModal";
import SecurePassTag from "@/components/SecurePass/SecurePassTag/SecurePassTag";
import NotFound from "@/pages/404";
import PageLoading from "@/pages/Dashboard/components/PageLoading";
import RouteMap from "./components/RouteMap";
import ShipmentActionsButton from "./components/ShipmentActionsButton";
import ShipmentStatusCard from "./components/ShipmentStatusCard/ShipmentStatusCard";
import ShipperAndTransporterInfo from "./components/ShipperAndTransporterInfo/ShipperAndTransporterInfo";
import TripDetails from "./components/TripDetails/TripDetails";
import VehicleListContainer from "./components/VehicleListContainer/VehicleListContainer";
import CancelShipmentModal from "./components/overlaid/CancelShipmentModal";
import DeleteReasonModal from "./components/overlaid/DeleteReasonModal";
import EditVehicleDrawer from "./components/overlaid/EditVehicleDrawer";
import TransferVehicleModal from "./components/overlaid/TransferVehicleModal";

const getTitle = shipmentData => (
  <section style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <span>
      Shipment Id:
      <CopyableGUID guid={shipmentData?.id} itemStyle={{ marginLeft: 5 }} />
    </span>
    <span style={{ display: "flex" }}>
      <SecurePassTag tagStatus={shipmentData?.securePass} />
    </span>
  </section>
);

const ShipmentDetails = ({ loading, dispatch, shipmentData, showMap }) => {
  const {
    shipmentId: shipmentIdURLParam,
    vin: searchVIN,
    showMap: showMapURLParam,
  } = getUrlParams(["shipmentId", "vin", "showMap"]);

  useEffect(() => {
    window.scrollTo(0, 0);

    dispatch({
      type: "shipmentDetails/fetchSingleShipment",
      shipmentId: shipmentIdURLParam,
    }).then(res => {
      if (res?.status === ShipmentStatus.Completed && searchVIN) {
        // set this to scroll to element containing vehicle info matching this vin on page
        // only doing this if shipment is confirmed status,
        // don't scroll if it is any other status, just stay at top of page with tracker
        window.location.href = `#${searchVIN}`;
      }

      dispatch({
        type: "shipmentDetails/toggleMapVisible",
        payload: Boolean(showMapURLParam),
      });
    });
  }, [shipmentIdURLParam, searchVIN, showMapURLParam, dispatch]);

  if (loading || loading === undefined) {
    return <PageLoading />;
  }

  if (shipmentData === null) {
    return <NotFound />;
  }

  return (
    <PageHeaderWrapper
      onBack={() => window.history.back()}
      title={getTitle(shipmentData)}
      extra={shipmentData.status <= ShipmentStatus.Delivered && <ShipmentActionsButton />}
    >
      <ShipmentStatusCard />
      {showMap && <RouteMap />}
      <TripDetails />
      <VehicleListContainer />
      <ShipperAndTransporterInfo />

      {/* Overlaid components */}
      <TransferVehicleModal />
      <CancelShipmentModal />
      <DeleteReasonModal />
      <EditVehicleDrawer />
      <DealerExchangeModal
        shipmentId={shipmentData.id}
        hideModal={() => {
          dispatch({
            type: "shipmentDetails/toggleDealerExchangeModalVisible",
            payload: false,
          });
        }}
      />
    </PageHeaderWrapper>
  );
};

export default connect(({ shipmentDetails, loading }) => ({
  shipmentData: shipmentDetails.data,
  loading: loading.effects["shipmentDetails/fetchSingleShipment"],
  showMap: shipmentDetails.showMap,
}))(ShipmentDetails);
